import { InfoCircleOutlined } from '@ant-design/icons';
import { ChevronDown } from 'lucide-react';

import { Flex } from '@/components/base';
import Button from '@/components/Button/Button';
import Menu from '@/components/Menu/Menu';
import TooltipV2 from '@/components/Tooltip/TooltipV2';
import Typo from '@/components/Typography/Typo';
import {
  CHART_SHARE_CALCULATION_TYPE,
  type CHART_SHARE_CALCULATION_TYPE as ChartShareCalculationType,
} from '@/entities/chart/model/constants';
import { ChartShareCalculationTypeMap } from '@/features/(charts)/chart-renderer/model/chart-maps';

type Props = {
  value: ChartShareCalculationType;
  onChange: (value: ChartShareCalculationType) => void;
  showCellOption?: boolean;
};

export const CalculationSelect = (props: Props) => {
  const { value, onChange, showCellOption = true } = props;
  const options = ChartShareCalculationTypeMap.toArray().filter((item) => {
    return (
      showCellOption || item.value !== CHART_SHARE_CALCULATION_TYPE.CELL
    );
  });

  return (
    <Flex j="flex-end" a="center">
      <InfoCircle showCellOption={showCellOption} />
      <Menu
        modalWidth={200}
        triggerNode={
          <Button
            className="-mr-2"
            variant="ghost"
            sizeType="m"
            rightIcon={<ChevronDown className="size-3 text-gray-600" />}
          >
            {ChartShareCalculationTypeMap.get(value)}
          </Button>
        }
        options={options.map((item) => ({
          label: item.label,
          onClick: () => onChange(item.value),
        }))}
      />
    </Flex>
  );
};

const InfoCircle = ({ showCellOption }: { showCellOption: boolean }) => {
  return (
    <TooltipV2
      tooltipNode={
        <div>
          <Typo type="body3">
            <strong>% of grand total:</strong> Share to the entire dataset.
            <br />
            <strong>% of row:</strong> Share to the row total.
            <br />
            <strong>% of column:</strong> Share to the column total.
          </Typo>
          {showCellOption && (
            <>
              <Typo type="body3">
                <strong>% of cell:</strong>
                <br />
              </Typo>
              <ul style={{ paddingLeft: 24 }}>
                <li>
                  <strong>Negative:</strong> Share of negative sentiment in the
                  cell.
                </li>
                <li>
                  <strong>Positive:</strong> Share of positive sentiment in the
                  call.
                </li>
              </ul>
              <Typo type="body3">
                (A feedback can contain multiple sentiments, so the combined
                ratio may exceed 100%)
              </Typo>
            </>
          )}
        </div>
      }
    >
      <Typo className="text-gray-600" type="label2">
        <InfoCircleOutlined />
      </Typo>
    </TooltipV2>
  );
};
